import axios from 'axios';

/* LOT 13 · 13.3 · un onglet n'agit jamais sur un autre compte.
   Chaque requête porte le compte de la page ; si la session a changé (autre onglet), écran bloquant + Recharger. */
const canal = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel('360-compte') : null;
let affiche = false;

const nomDe = async (slug) => {
  try { const r = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/tenants/${slug}`); return r.data?.name || slug; } catch { return slug; }
};

export const afficherCompteChange = async (nom) => {
  if (affiche) return;
  affiche = true;
  const fond = document.createElement('div');
  fond.setAttribute('data-testid', 'compte-change');
  fond.setAttribute('role', 'alertdialog');
  fond.style.cssText = 'position:fixed;inset:0;z-index:2147483000;background:rgba(28,23,20,.55);backdrop-filter:blur(6px);display:flex;align-items:center;justify-content:center;padding:24px;font-family:Inter,sans-serif';
  const carte = document.createElement('div');
  carte.style.cssText = 'background:#fff;border-radius:18px;padding:22px;max-width:360px;width:100%;box-shadow:0 20px 60px rgba(0,0,0,.25);display:flex;flex-direction:column;gap:14px;color:#1C1714';
  const p = document.createElement('p');
  p.style.cssText = 'margin:0;font-size:16px;line-height:1.45;font-weight:600';
  p.setAttribute('data-testid', 'compte-change-texte');
  p.textContent = `Vous êtes maintenant connecté à ${nom}. Rechargez la page pour continuer.`;
  const b = document.createElement('button');
  b.type = 'button';
  b.textContent = 'Recharger';
  b.setAttribute('data-testid', 'compte-change-recharger');
  b.style.cssText = 'height:46px;border-radius:999px;border:0;background:#1C1714;color:#fff;font-weight:700;font-size:15px;cursor:pointer';
  b.onclick = () => window.location.reload();
  carte.append(p, b);
  fond.append(carte);
  document.body.append(fond);
};

export const installerGardeCompte = () => {
  axios.interceptors.request.use((cfg) => {
    const slug = window.__TENANT_SLUG__;
    if (slug) cfg.headers = { ...(cfg.headers || {}), 'X-Tenant-Slug': slug };
    return cfg;
  });
  axios.interceptors.response.use((r) => {
    if (/\/api\/auth\/(login|session|google|register|accept|activate)/.test(r.config?.url || '') && r.data?.user?.tenant_id) canal?.postMessage({ slug: r.data.user.tenant_id });
    return r;
  }, (e) => {
    const d = e.response?.data;
    if (e.response?.status === 409 && d?.detail === 'compte_change') afficherCompteChange(d.compte);
    return Promise.reject(e);
  });
  if (canal) canal.onmessage = async (ev) => {
    const slug = ev.data?.slug;
    if (slug && window.__TENANT_SLUG__ && slug !== window.__TENANT_SLUG__) afficherCompteChange(await nomDe(slug));
  };
};
